import React, { useRef, ReactNode } from 'react';
import { useIsMobile } from '../hooks/useIsMobile';

interface SpotlightCardProps {
    children: ReactNode;
    className?: string;
}

export const SpotlightCard: React.FC<SpotlightCardProps> = ({ children, className = '' }) => {
    const isMobile = useIsMobile();
    const divRef = useRef<HTMLDivElement>(null);

    const onMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        if (isMobile || !divRef.current) return;
        const { clientX, clientY } = e;
        const { left, top } = divRef.current.getBoundingClientRect();
        const x = clientX - left;
        const y = clientY - top;
        divRef.current.style.setProperty('--mouse-x', `${x}px`);
        divRef.current.style.setProperty('--mouse-y', `${y}px`);
    };

    return (
        <div
            ref={divRef}
            className={`spotlight-card ${className}`}
            onMouseMove={onMouseMove}
        >
            {children}
        </div>
    );
};
